import axios from 'axios'
import { instanceApiary, primeiraVersaoApiary, instanceOEF, segundaVersaoOEF } from './api'
import { transformarRespostaEmCamel } from '../utils/formatter/formatter'

export const getBoletoFuturo = idAssinatura => instanceOEF.post( `${segundaVersaoOEF}/gerar-boleto`, { 'assinatura_id': idAssinatura }, {
  'transformResponse': axios.defaults.transformResponse.concat( dados => transformarRespostaEmCamel( dados ) )
} )

export const getSegundaVia = idAssinatura => instanceApiary.post( `${primeiraVersaoApiary}/gerar-segunda-via-boleto`, { idAssinatura } )
